import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCertificationFormats({ organization_id, certification_id, certification_version_id }) {
    return RequesterV1.get(
      `organization/certifications/query_formats/list_formats/${organization_id}/${certification_id}/${certification_version_id}`
    );
  },
  fetchCertificationVersion({ organization_id, certification_id, certification_version_id }) {
    return RequesterV1.get(
      `organization/certifications/query_formats/list_formats/${organization_id}/${certification_id}/${certification_version_id}/fetch_certification_version`
    );
  }
};
